import React from 'react';
import PropTypes from 'prop-types';
import ShowPageWrapper from '../components/ShowPageWrapper';
import StoryContent from '../components/textEditor/StoryContent';

export default function ShowPage({ appData }) {
  const { storyId } = JSON.parse(appData);
  return (
    <ShowPageWrapper storyId={storyId}>
      <StoryContent storyId={storyId} readOnlyMode />
    </ShowPageWrapper>
  );
}

ShowPage.propTypes = {
  appData: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/pages/ShowPage.jsx